import React from 'react';
import { ContactDetails } from 'components/contact-details';
import { FooterMenu } from 'components/footer/footer-menu';
import { Social } from 'components/social';
import { useSelector } from 'react-redux';
import madeinbritainlogo from '../../assets/images/made-in-britain.png';
import styles from './style.module.scss';

export const Footer = () => {
  const menus = useSelector((state) => state.navMenus.data);
  let companyLinks;
  let resourcesLinks;
  let legalLinks;

  try {
    companyLinks = menus.company.map((link) => {
      return {
        name: link.title,
        path: link.url,
      };
    });

    resourcesLinks = menus.resources.map((link) => {
      return {
        name: link.title,
        path: link.url,
      };
    });

    legalLinks = menus.legal.map((link) => {
      return {
        name: link.title,
        path: link.url,
      };
    });
  } catch (error) {
    console.error(
      'Footer Menu Unavailable: A footer menu (company, resources or legal) has not been defined in the CMS'
    );
  }

  return (
    <footer className={styles.footer}>
      <div className={`${styles.wrapper} container`}>
        <ContactDetails />
        <div className={styles['inner-wrapper']}>
          <FooterMenu title="Company" navList={companyLinks} />
          <FooterMenu title="Resources" navList={resourcesLinks} />
          <FooterMenu title="Legals" navList={legalLinks} />
          <div>
            <Social extraClass={'footer-social'} noHeader={false} />
            <div>
              <img
                className={styles['made-in-britain']}
                src={madeinbritainlogo}
                alt="Made In Britain Logo"
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.copyright}>
        <p>
          Copyright (c) {new Date().getFullYear()} Orluna LED Technologies
          Limited, registered in England and Wales. 10694684.
        </p>
      </div>
    </footer>
  );
};
